import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { StepContext } from './Components/StepContext.jsx';
import { KycProvider } from './Components/KycContext.jsx';
// import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT}>
        {/* <ErrorBoundary> */}
            <StepContext>
                <KycProvider>
                    <App />
                </KycProvider>
            </StepContext>
        {/* </ErrorBoundary> */}
    </GoogleOAuthProvider>
);
